import { render, staticRenderFns } from "./replyCreator.vue?vue&type=template&id=3527123f&scoped=true&"
import script from "./replyCreator.vue?vue&type=script&lang=js&"
export * from "./replyCreator.vue?vue&type=script&lang=js&"
import style0 from "./replyCreator.vue?vue&type=style&index=0&id=3527123f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3527123f",
  null
  
)

export default component.exports